/** Display choices only. Never use these values for authorization or persisted data. */
export function createPresentation(mode?: string, organizationName?: string) {
  const isGeneric = mode === "generic";
  const name = organizationName?.trim().slice(0, 120) || "Votre organisation";
  return {
    isGeneric,
    productName: isGeneric ? "HAWK" : "FLUX",
    organizationName: isGeneric ? name : "Présidence de la République du Bénin",
    shortOrganizationName: isGeneric ? name : "Présidence du Bénin",
    label: (existing: string, generic: string) => isGeneric ? generic : existing,
  };
}
